var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('v-avatar',{attrs:{"rounded":"","size":"","width":"100vw","height":"100vh"}},[_c('img',{attrs:{"src":"https://www.wpbeginner.com/wp-content/uploads/2013/04/wp404error.jpg","alt":""}})]),_vm._v(" >")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }